import Trash from 'assets/icons/Trash';
import Button from 'common/components/Button';
import useTranslation from 'common/hooks/useTranslation';
import { selectCurrentCompany } from 'common/slices/auth.slice';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import DeleteCompanyModal from './DeleteCompanyModal';

const DeleteCompanySection = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const currentCompany = useSelector(selectCurrentCompany);

  const { t } = useTranslation('settings\\index');

  return (
    <div className='w-1/3'>
      <Button
        type='button'
        variant='primary'
        onClick={() => setModalIsOpen(true)}
      >
        <div className='flex items-center gap-2'>
          {t('advanced-tab-sections.deactivate-company.buttons.deactivate')}
          <Trash size={14} color='white' />
        </div>
      </Button>
      <DeleteCompanyModal
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        currentCompanyId={currentCompany?.id}
        currentCompanyName={currentCompany?.name}
      />
    </div>
  );
};

export default DeleteCompanySection;
